import { Pedido } from "../dto/Pedidos";
import { enviaMsgSucesso } from "../helpers/Notificacoes";
import api from "../config/api";
import { tratarErroRequisicao } from "../helpers/Errors";

const { REACT_APP_BASE_URL } = process.env || "";

export class PedidosServices {
    private readonly baseUrl: string;
    private readonly onUnauthorized?: () => void;

    constructor(onUnauthorized?: () => void) {
        this.baseUrl = REACT_APP_BASE_URL!;
        this.onUnauthorized = onUnauthorized;
    }

    async get(path: string, options: RequestInit = {}) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.get(path, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Busca Pedidos", response.data);
        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async patch(path: string, options: RequestInit = {}, payload: Pedido[]) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.patch(path, payload, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Patch Pedido", response.data);
        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async put(path: string, options: RequestInit = {}, payload: Pedido[]) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.put(path, payload, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Put Pedido", response.data);

        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async updatePedido(path: string, options: RequestInit = {}, payload: Pedido[]) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.put(path, payload, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Update Pedido", response.data);

        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async cancelaPedido(path: string, options: RequestInit = {}, payload: Pedido[]) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.put(path, payload, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Cancela Pedido", response.data);
        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async deletePedido(path: string, options: RequestInit = {}, payload: Pedido[]) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.patch(path, payload, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Delete Pedido", response.data);
        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async downloadPdf(path: string, nomeArquivoPadrao: string = 'pedido.pdf') {
        try {
            const response = await api.get(path, {
                responseType: 'blob',
                signal: this.createTimeoutSignal(10000),
            });

            const contentDisposition = response.headers?.['content-disposition'] as string | undefined;
            let nomeArquivo = nomeArquivoPadrao;

            if (contentDisposition) {
                const matchUtf8 = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
                const matchPadrao = contentDisposition.match(/filename="?([^";]+)"?/i);
                const nomeExtraido = matchUtf8?.[1] || matchPadrao?.[1];

                if (nomeExtraido) {
                    nomeArquivo = decodeURIComponent(nomeExtraido.trim().replace(/['"]/g, ''));
                }
            }

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = nomeArquivo;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            return enviaMsgSucesso(200, "Download PDF Pedido", { nomeArquivo });
        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    private createTimeoutSignal(timeout: number): AbortSignal | undefined {
        const controller = new AbortController();
        setTimeout(() => controller.abort(), timeout);
        return controller.signal;
    }

}